import React, { SVGProps } from 'react'

const MicIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'
      {...props}
    >
      <path
        d='M17.828 21.2858C16.6127 21.2858 15.5797 20.8604 14.729 20.0097C13.8783 19.159 13.453 18.126 13.453 16.9108V8.16077C13.453 6.94549 13.8783 5.9125 14.729 5.06181C15.5797 4.21111 16.6127 3.78577 17.828 3.78577C19.0432 3.78577 20.0762 4.21111 20.9269 5.06181C21.7776 5.9125 22.203 6.94549 22.203 8.16077V16.9108C22.203 18.126 21.7776 19.159 20.9269 20.0097C20.0762 20.8604 19.0432 21.2858 17.828 21.2858ZM16.3696 31.4941V27.0097C13.8419 26.6694 11.7516 25.5392 10.0988 23.6191C8.44602 21.699 7.61963 19.4628 7.61963 16.9108H10.5363C10.5363 18.9281 11.2472 20.6477 12.6691 22.0696C14.091 23.4915 15.8106 24.2024 17.828 24.2024C19.8453 24.2024 21.5649 23.4915 22.9868 22.0696C24.4087 20.6477 25.1196 18.9281 25.1196 16.9108H28.0363C28.0363 19.4628 27.2099 21.699 25.5571 23.6191C23.9044 25.5392 21.8141 26.6694 19.2863 27.0097V31.4941H16.3696Z'
        fill='currentcolor'
      />
    </svg>
  )
}

export default MicIcon
